import { IAppState } from '../../store';

export const selectRealtorName = (state: IAppState) => state.realtor.name;
